import axiosInstance from "./utils";
import store from "../store";

export default {
  getParkings(clientId) {
    return axiosInstance
      .get(`parkings/${clientId}`)
      .then((response) => response.data)
      .catch((err) => {
        console.error("Error on get parkings", err);
      });
  },

  createParking(clientId, data) {
    return axiosInstance
      .post(`parkings/${clientId}`, data)
      .then((response) => response.data)
      .catch((err) => {
        console.error("Error on create parking", err);
        store.dispatch("add_error_queue", {
          error: err,
          message: "Une erreur est survenu lors de la création du parking",
        });
      });
  },

  updateParking(clientId, data) {
    return axiosInstance
      .put(`parkings/${clientId}/${data.id}`, data)
      .then((response) => response.data)
      .catch((err) => {
        console.error("Error on update parking", err);
        store.dispatch("add_error_queue", {
          error: err,
          message: "Une erreur est survenu lors de l'édition du parking",
        });
      });
  },

  deleteParking(clientId, id) {
    return axiosInstance
      .delete(`parkings/${clientId}/${id}`)
      .then((response) => response.data)
      .catch((err) => {
        console.error("Error on delete parking", err);
        store.dispatch("add_error_queue", {
          error: err,
          message: "Une erreur est survenu lors de la suppression du parking",
        });
      });
  },
};
